(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8643],{

/***/ 17876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Img_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53068);
/* harmony import */ var _Img_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Img_module_scss__WEBPACK_IMPORTED_MODULE_3__);






// import { LazyImage } from 'react-lazy-images';

// eslint-disable-next-line react/prop-types
var Img = function(_param) {
    var className = _param.className, wrapperClassName = _param.wrapperClassName, height = _param.height, width = _param.width, src = _param.src, alt = _param.alt, style = _param.style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "wrapperClassName",
        "height",
        "width",
        "src",
        "alt",
        "style"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(wrapperClassName, (_Img_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container)),
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            display: "inline-block",
            color: "transparent"
        }, style), {
            height: height,
            width: width
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, (_Img_module_scss__WEBPACK_IMPORTED_MODULE_3___default().fadeIn)),
            loading: "lazy",
            src: src,
            alt: alt,
            height: height,
            width: width
        }, props))
    });
};
Img.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    wrapperClassName: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    src: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Img);


/***/ }),

/***/ 58643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _components_PageComponents_Hero_HeroButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61522);
/* harmony import */ var _components_Section__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50943);
/* harmony import */ var _components_Layout_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93651);
/* harmony import */ var _components_Img__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17876);
/* harmony import */ var _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10966);
/* harmony import */ var _styles_error_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12445);
/* harmony import */ var _styles_error_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_error_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var Error = function(props) {
    var head = {
        title: "Page Not Found | Hire Digital",
        meta: [
            {
                name: "description",
                content: "The page you're looking for no longer exists. Please contact us if this is a mistake."
            }, 
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        pageHead: head,
        className: (_styles_error_module_scss__WEBPACK_IMPORTED_MODULE_6___default().body),
        darkFooter: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Section__WEBPACK_IMPORTED_MODULE_2__/* .SectionContainer */ .S, {
            className: (_styles_error_module_scss__WEBPACK_IMPORTED_MODULE_6___default().sectionContainer),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_error_module_scss__WEBPACK_IMPORTED_MODULE_6___default().imageContainer),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Img__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        src: "/img/hero/office.webp",
                        alt: "image",
                        className: (_styles_error_module_scss__WEBPACK_IMPORTED_MODULE_6___default().imageItem),
                        wrapperClassName: (_styles_error_module_scss__WEBPACK_IMPORTED_MODULE_6___default().image)
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Section__WEBPACK_IMPORTED_MODULE_2__/* .Section */ .$, {
                    className: (_styles_error_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_error_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                element: "h1",
                                className: (_styles_error_module_scss__WEBPACK_IMPORTED_MODULE_6___default().headline),
                                size: _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Size.HEADLINE */ .Z.Size.HEADLINE,
                                color: _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Color.WHITE */ .Z.Color.WHITE,
                                children: "Page Not Found"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: (_styles_error_module_scss__WEBPACK_IMPORTED_MODULE_6___default().subheadline),
                                size: _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Size.H3 */ .Z.Size.H3,
                                color: _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Color.WHITE */ .Z.Color.WHITE,
                                children: "The page you're looking for no longer exists. Please contact us if this is a mistake."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageComponents_Hero_HeroButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                className: (_styles_error_module_scss__WEBPACK_IMPORTED_MODULE_6___default().button),
                                type: _components_PageComponents_Hero_HeroButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Type.WHITE */ .Z.Type.WHITE,
                                to: "/",
                                title: "Back Home",
                                children: "Back to Home"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageComponents_Hero_HeroButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                id: "intercom-chat",
                                href: "#",
                                className: (_styles_error_module_scss__WEBPACK_IMPORTED_MODULE_6___default().button),
                                type: _components_PageComponents_Hero_HeroButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Type.WHITE_OUTLINE */ .Z.Type.WHITE_OUTLINE,
                                title: "Get Help",
                                children: "Get Help"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Error);


/***/ }),

/***/ 53068:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"Img_fadeIn__2th1r","container":"Img_container__MfUcM","image":"Img_image__C4ftI"};

/***/ })

}]);